import {NetworkStrategy} from './NetworkStrategy'

export class NeoN3Network implements NetworkStrategy {
  buildPayload(params: any) {
    return {
      scriptHash: params.scriptHash,
      operation: params.operation,
      args: params.args,
    }
  }
}
